import {ACTION_CODE} from './_actionCode';
import {ContractorCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';

const FUNCTION_CODE = 'DELETE_CONTRACTOR_CATEGORY';

export async function deleteContractorCategory(userData = {}, contractorCategoryId: number | string) {
    try {
        LoggerService.logInfo('Action - deleteContractorCategory - Start');

        const result = await ContractorCategoryService.deleteContractorCategory(userData, contractorCategoryId);

        LoggerService.logInfo('Action - deleteContractorCategory - End - Success');

        return ResultModel.newSuccessResult(result);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteContractorCategory - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression de la catégorie sous/co-traitant',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
